import React, { useEffect, useState, useCallback } from "react";
import {
  Icon,
  Grid,
  Divider,
  Checkbox,
  Modal,
  Label,
  Form,
  Message, Button
} from "semantic-ui-react";
import { useAuth } from "../../AuthenticationStore";

export const Segmentation = ({
  cdFiltersCampaign,
  modification,
  onChangeValuesObject,
  errors
}) => {
  const { campaignService } = useAuth();

  const typeObjectName = "cdFiltersCampaign";
  const [varsStructure, setVarsStructure] = useState([]);
  const [modalSegmentValues, setModalSegmentValues] = useState([]);
  const [optionsAttribute, setOptionsAttribute] = useState([]);

  const [readOnly, setReadOnly] = useState(false);
  useEffect(() => {
    setReadOnly(modification === false);
  }, [modification]);

  useEffect(() => {
    if (!campaignService) return;
    // call api return vars structure
    campaignService
      .getAllVariablesCampaign()
      .then(res => {
        if (res.cdExceptions.length > 0) {
          return alert("error no se cargaron las variables");
        }
        setVarsStructure(res.object);
      })
      // eslint-disable-next-line no-console
      .catch(err => console.log(err));
  }, [campaignService]);

  const verifyCheck = useCallback(
    name => {
      for (let i = 0; i < cdFiltersCampaign.length; i++) {
        const varObject = cdFiltersCampaign[i];
        if (varObject.attribute === name) return true;
      }
      return false;
    },
    [cdFiltersCampaign]
  );

  const checkVar = (index, checked) => {
    let varsCopy = Object(cdFiltersCampaign, []);
    if (checked) {
      varsCopy.push({
        attribute: varsStructure[index]["name"],
        maxValue: 0,
        minValue: 0,
        options: [],
        typo: varsStructure[index]["type"]
      });
    } else {
      const internalIndex = varsCopy.findIndex(
        item => item.attribute === varsStructure[index]["name"]
      );
      varsCopy[internalIndex] = undefined;
    }
    // only send defined object vars
    onChangeValuesObject(typeObjectName, varsCopy.filter(item => item));
  };

  const validateSupplied = useCallback(
    name => {
      const internalIndex = cdFiltersCampaign.findIndex(
        item => item && item.attribute === name
      );

      if (
        cdFiltersCampaign[internalIndex] &&
        [1, 2].indexOf(cdFiltersCampaign[internalIndex]["typo"]) > -1
      ) {
        if (cdFiltersCampaign[internalIndex]["maxValue"] <= 1) {
          return true;
        }
        return false;
      } else if (
        cdFiltersCampaign[internalIndex] &&
        cdFiltersCampaign[internalIndex]["typo"] === 0
      ) {
        if (cdFiltersCampaign[internalIndex]["options"].length === 0) {
          return true;
        }
        return false;
      } else {
        return true;
      }
    },
    [cdFiltersCampaign]
  );

  const [errorsList, setErrorsList] = useState([]);

  const getOptionsAttribute = (item, index) => {
    // open modal
    modalSegmentValues[index] = true;
    setModalSegmentValues([...modalSegmentValues]);

    setErrorsList([]);

    if ([1, 2].indexOf(item.type) > -1) return;

    campaignService
      .getOptionVariableCampaign(item.name)
      .then(res => {
        if (res.cdExceptions.length > 0) {
          const errors = [];
          for (let index = 0; index < res.cdExceptions.length; index++) {
            errors.push(res.cdExceptions[index]["exception"]);
          }
          setErrorsList(errors);
          setOptionsAttribute([]);
          return;
        }

        const optionsAttributeTemp = res.object.listValue.map((item, key) => {
          return { key, text: item, value: item };
        });

        setOptionsAttribute(optionsAttributeTemp);
      })
      // eslint-disable-next-line no-console
      .catch(err => console.log(err));
  };

  const onChangeInputRange = useCallback(
    (_, newValue) => {
      const internalIndex = cdFiltersCampaign.findIndex(
        item => item && item.attribute === newValue["data-name"]
      );
      let varsCopy = Object(cdFiltersCampaign, []);
      let valueReplace = {};

      if (newValue["data-is-min"])
        valueReplace = {
          minValue: Number(newValue.value)
        };

      if (newValue["data-is-max"])
        valueReplace = {
          maxValue: Number(newValue.value)
        };

      if (newValue["data-is-options"])
        valueReplace = {
          options: newValue.value
        };

      varsCopy[internalIndex] = Object.assign(
        varsCopy[internalIndex],
        valueReplace
      );

      onChangeValuesObject(typeObjectName, varsCopy.filter(item => item));
    },
    [cdFiltersCampaign, onChangeValuesObject]
  );

  const getVarValueAttribute = (name, type) => {
    const internalIndex = cdFiltersCampaign.findIndex(
      item => item && item.attribute === name
    );

    return cdFiltersCampaign[internalIndex]
      ? cdFiltersCampaign[internalIndex][type]
      : 0;
  };

  /**
   * closeModalSegmentationValues
   * @param {number} index ubication modal in array
   */
  const closeModalSegmentationValues = index => {
    modalSegmentValues[index] = false;
    setModalSegmentValues([...modalSegmentValues]);
  };

  return (
    <Grid>
      {errors && (errors.segmentation || errors.options) ? (
        <Grid.Row>
          <Grid.Column>
            <Message negative>
              <Message.Header>Error</Message.Header>
              <p>{errors.segmentation || errors.options}</p>
            </Message>
          </Grid.Column>
        </Grid.Row>
      ) : null}
      <Divider fitted />
      <Grid.Row>
        {varsStructure.map((item, index) => {
          return (
            <Grid.Column
              className="campaign-new__steps-segmentation-item-column"
              key={index}
              mobile={16}
              tablet={7}
              computer={5}
            >
              <Grid columns={1}>
                <Grid.Row>
                  <Grid.Column className="campaign-new__steps-segmentation-item-vars">
                    <div class="col-md-4">
                      <Checkbox
                        disabled={readOnly}
                        toggle
                        label={item.cultureName || item.name}
                        checked={verifyCheck(item.name)}
                        onChange={(__, data) => checkVar(index, data.checked)}
                      />
                    </div>
                    <Modal
                      open={modalSegmentValues[index]}
                      onClose={() => closeModalSegmentationValues(index)}
                      size={"small"}
                      trigger={
                        verifyCheck(item.name) ? (
                          <span className="campaign-new-steps-segmentatio-item-vars__setting-content">
                            {validateSupplied(item.name) ? (
                              <Label
                                circular
                                color="red"
                                className="campaign-new-steps-segmentatio-item-vars__setting-alert"
                              >
                                !
                              </Label>
                            ) : null}
                            <Icon
                              circular
                              className="campaign-new__steps-segmentation-item-vars__setting"
                              name="setting"
                              onClick={() => getOptionsAttribute(item, index)}
                            />
                          </span>
                        ) : null
                      }
                    >
                      <Modal.Header className="bg-primary"><i class="fa fa-gears"></i> Configuracion variable:  {item.cultureName || item.name}</Modal.Header>
                      <Modal.Content>
                        {errorsList && errorsList.length > 0 ? (
                          <Message negative list={errorsList} />
                        ) : null}
                        <Modal.Description>
                          <Form>
                            {item.type === 2 ? <p>Rango en dias</p> : null}

                            {item.type === 0 ? (
                              <Form.Select
                                fluid
                                label=""
                                disabled={readOnly}
                                data-name={item.name}
                                data-is-options
                                multiple
                                options={optionsAttribute}
                                onChange={onChangeInputRange}
                                value={getVarValueAttribute(
                                  item.name,
                                  "options"
                                )}
                              />
                            ) : null}

                            {[1, 2].indexOf(item.type) > -1 ? (
                              <Form.Group widths="equal">
                                <Form.Field>
                                  <label>Desde</label>
                                  <Form.Input
                                    disabled={readOnly}
                                    type="number"
                                    data-name={item.name}
                                    data-is-min
                                    onChange={onChangeInputRange}
                                    value={getVarValueAttribute(
                                      item.name,
                                      "minValue"
                                    )}
                                  />
                                </Form.Field>
                                <Form.Field>
                                  <label>Hasta</label>
                                  <Form.Input
                                    disabled={readOnly}
                                    type="number"
                                    data-name={item.name}
                                    data-is-max
                                    onChange={onChangeInputRange}
                                    value={getVarValueAttribute(
                                      item.name,
                                      "maxValue"
                                    )}
                                  />
                                </Form.Field>
                              </Form.Group>
                            ) : null}
                          </Form>
                        </Modal.Description>
                      </Modal.Content>
                      <Modal.Actions>
                        <Button
                          onClick={() => closeModalSegmentationValues(index)}
                          className="btn-sm bg-primary btn-md"
                          style={{ color: "white" }}
                        >
                          <Icon name="checkmark" /> Finalizar
                        </Button>
                      </Modal.Actions>
                    </Modal>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Grid.Column>
          );
        })}
      </Grid.Row>
    </Grid>
  );
};

Segmentation.defaultProps = {
  cdFiltersCampaign: []
};
